import { createStore } from '../core/store.ts';

/**
 * Партнёрская вставка (демо): полноэкранный креатив после оплаченного заказа. Показывается
 * не чаще раза в двадцать минут и никогда сама по себе — только как пауза между оплатой и
 * экраном заказа.
 */
export const partnerPromoStore = createStore<{ showsInterstitial: boolean }>({ showsInterstitial: false });

const QUIET_MS = 20 * 60_000;
let lastShown = 0;

/** Оплата прошла. Короткая пауза даёт листу оформления закрыться раньше, чем встанет креатив. */
export function presentPartnerPromoAfterPayment(): void {
  if (Date.now() - lastShown < QUIET_MS) return;
  lastShown = Date.now();
  setTimeout(() => partnerPromoStore.set({ showsInterstitial: true }), 700);
}

export function dismissPartnerPromo(): void {
  partnerPromoStore.set({ showsInterstitial: false });
}
